import React from 'react';
import { Card } from 'react-bootstrap';

const CommonCard = ({ children }: { children: React.ReactNode }) => {
  return <Card className='profile-right-side px-3 py-3'>{children}</Card>;
};

export default CommonCard;
